import React, { useRef, useEffect, useState } from 'react';
import { Container, CardBody, Card } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { PreviewHTML } from 'vivace-fluent-motion';
import * as commonActions from '@common/common.action';
import RelatorioApi from '../../../relatorio.api';
import { returnParamiters, returnStatus } from '../../../relatorio.utils';
import Impressao from './Impressao';
import IntlMessage from '../../../../../../src/helpers/intlMessage';

function Relatorio ({
  lista,
  showModalImprimir,
  setShowModalImprimir,
  total,
  filtro
}) {
  const componentRef = useRef();
  const dispatch = useDispatch();

  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const [previewHTML, setPreviewHTML] = useState(false);
  const [laudos, setLaudos] = useState([]);
  const [laudosFormatados, setLaudosFormatados] = useState([]);

  useEffect(() => {
    if (showModalImprimir) {
      if (lista && total > lista.length) {
        filtrar({ ...filtro, pagina: 1, lista: [] });
      } else {
        setLaudos(lista);
        setPreviewHTML(true);
      }
    }
  }, [showModalImprimir]);

  useEffect(() => {
    const listaFormatada = laudos.map(laudo => {
      const { label } = returnStatus(laudo);
      return {
        ...laudo,
        urgente: laudo.urgente ? 'SIM' : 'NÃO',
        statusText: label
      };
    });
    setLaudosFormatados(listaFormatada);
  }, [laudos]);

  const filtrar = async filtro => {
    try {
      const {
        medico,
        periodoInicial,
        periodoFinal,
        tipo,
        value,
        pagina,
        lista
      } = filtro;

      let params = returnParamiters({
        periodoInicial,
        periodoFinal,
        tipo,
        value
      });

      if (medico) params.medicoSolicitante = medico;

      dispatch(commonActions.showFadeCarregando(true));
      const response = await RelatorioApi.getLaudos(pagina, params);
      const novaLista = [...lista, ...response.listagem];

      if (novaLista.length < total) {
        return filtrar({ ...filtro, pagina: pagina + 1, lista: novaLista });
      }

      setLaudos(novaLista);
      dispatch(commonActions.showFadeCarregando(false));
      setPreviewHTML(true);
    } catch (error) {
      dispatch(commonActions.showFadeCarregando(false));
    }
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  const ComponentHTML = ({ id }) => {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                <Impressao lista={laudosFormatados} />
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div>
      <PreviewHTML
        messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
        printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
        visible={previewHTML}
        id='uniqueID'
        component={<ComponentHTML id='uniqueID' />}
        onOpened={e => {
          setPreviewHTML(e);
          setShowModalImprimir(e);
        }}
        onPrint={handlePrint}
      />
    </div>
  );
}

export default Relatorio;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Relatorios/LaudosCriticos/index.js